import { ErrorMessageType } from "@/types/error";

interface ErrorMessagesType {
  [code: number]: ErrorMessageType;
}

export const NetworkErrorMessages: ErrorMessagesType = {
  0: {
    description: "인터넷 연결이 불안정합니다.",
    action: "네트워크 상태를 확인한 후 다시 시도해 주세요!",
  },
  400: {
    description: "입력하신 정보에 문제가 있습니다.",
    action: "입력하신 정보를 다시 확인해 주세요!",
  },
  404: {
    description: "요청하신 데이터를 찾을 수 없습니다.",
    action: "입력하신 정보를 다시 확인해 주세요!",
  },
};

export const DefaultNetworkErrorMessage: ErrorMessageType = {
  description: "잠시 후에 다시 시도해주세요!",
  action: "",
};

export const DefaultErrorMessage: ErrorMessageType = {
  description: "요청을 처리하는 중 문제가 발생했습니다.",
  action: "문제가 계속되면 채널톡으로 문의해 주세요.",
};
